import React, {useContext, useEffect, useRef, useState} from 'react';
import {CorporationContext} from "../../context/corporation-context.jsx";
import InputForm from "../../../../../components/input/input-form.jsx";
import Button from "../../../../../components/button/button.jsx";
import {getNeighborhoods, getStreets} from "../../../../../utils/location-utils.js";
import OptionsUtils from "../../../../../utils/options-utils.js";
import {Card} from "../../../../../components/card/card.jsx";
import SelectComponent from "../../../../../components/select/select-component.jsx";
import ModalAddress from "../../../../../components/modal/modal-address.jsx";
import {MaskDefault} from "../../../../../utils/mask.js";

const CorporationData = () => {
    const {state, setState, setChanges, handleInputMask, userIsSentryDev} = useContext(CorporationContext)
    const [open, setOpen] = useState(false);
    const onChange = ({target: {value, id}}) => handleInputs(value, id)

    const onChangeSelection = (id, value) => handleInputs(value, id);

    const handleInputs = (value, id) => {
        setState(prev => ({...prev, [id]: value}));
        setChanges("corporation")
    }

    const handleMap = () => {
        setOpen(true);
    }

    const changeLocation = (latLng) => {
        handleInputs(latLng.lat(), "latitude")
        handleInputs(latLng.lng(), "longitude")
    }

    const onBlurPhone = (e) => {
        handleInputMask(e)
        setChanges("corporation")
    }

    return (
        <>
            <Card>
                <Card.Header className={"!justify-between"}>
                    <Card.Title>
                        Dados da corporação
                    </Card.Title>
                </Card.Header>
                <Card.Body>
                    <div className="grid grid-cols-2 gap-4">
                        <InputForm id="name" value={state.name} label="Nome *" disabled />
                        <div className={"relative"}>
                            <InputForm id="city" value={state.city} label="Município *" disabled />
                            <span className="absolute bottom-[5px] right-[6px] z-[2] bg-[#2f4050] text-white rounded-[4px] px-[5px] py-[2px]">ID:
                                <span id="prefix-span">{ state.prefix }</span>
                            </span>
                        </div>
                    </div>

                    <div className="grid grid-cols-12 gap-4 mt-3">
                        <div className="col-span-8">
                            <SelectComponent
                                loadOptions={getStreets}
                                value={OptionsUtils.getValue(state.address)}
                                isAsync
                                label="Logradouro *"
                                onChange={(selected) => onChangeSelection("address", selected?.value)}
                                cacheOptions
                                defaultOptions={[]}
                            />
                        </div>
                        <div className="col-span-4">
                            <InputForm id="number" value={state.number} label="Número *" onChange={onChange} />
                        </div>
                    </div>

                    <div className="grid grid-cols-12 gap-4 mt-3">
                        <div className="col-span-8">
                            <SelectComponent
                                loadOptions={getNeighborhoods}
                                value={OptionsUtils.getValue(state.neighborhood)}
                                isAsync
                                label="Bairro *"
                                onChange={(selected) => onChangeSelection("neighborhood", selected?.value)}
                                cacheOptions
                                defaultOptions={[]}
                            />
                        </div>
                        <div className="col-span-4">
                            <InputForm
                                id="phone"
                                name="phone"
                                value={state.phone}
                                onBlur={onBlurPhone}
                                onChange={onBlurPhone}
                                label="Telefone"
                                mask={MaskDefault.phone}
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-12 gap-4 mt-3">
                        <div className="col-span-8">
                            <InputForm id="institutional_email" value={state.institutional_email} label="E-mail" onChange={onChange} />
                        </div>
                        <div className="col-span-4">
                            <InputForm id="time_zone" value={state.time_zone} label="Fuso horário *" disabled onChange={onChange} />
                        </div>
                    </div>

                    <div className="grid grid-cols-12 gap-4 mt-3">
                        <div className="col-span-5">
                            <InputForm id="latitude" value={state.latitude} label="Latitude *" onChange={onChange} />
                        </div>
                        <div className="col-span-5">
                            <InputForm id="longitude" value={state.longitude} label="Longitude *" onChange={onChange} />
                        </div>
                        <div className="col-span-2 flex items-end">
                            <Button onClick={handleMap}>
                                Mapa
                            </Button>
                        </div>
                    </div>

                </Card.Body>
            </Card>

            <Card className="mt-2">
                <Card.Header className="!flex !items-center !gap-2">
                    <Card.Title>Suporte (Corporação)</Card.Title>
                </Card.Header>

                <Card.Body>
                    <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-4">
                            <InputForm
                                id="contacts_email"
                                value={state.contacts_email}
                                label="E-mail"
                                onChange={onChange}
                            />
                        </div>

                        <div className="col-span-4">
                            <InputForm
                                id="contacts_phone"
                                name="contacts_phone"
                                value={state.contacts_phone}
                                onBlur={onBlurPhone}
                                onChange={onBlurPhone}
                                label="Telefone"
                                mask={MaskDefault.phone}
                            />
                        </div>
                    </div>
                </Card.Body>
            </Card>

            <Card className="mt-2">
                <Card.Header className="!flex !items-center !gap-2">
                    <Card.Title>Inteligência</Card.Title>
                </Card.Header>

                <Card.Body>
                    <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-4">
                            <InputForm
                                id="ecap_name"
                                value={state.ecap_name}
                                label="Nome do relatório"
                                onChange={onChange}
                            />
                        </div>

                        <div className="col-span-4">
                            <InputForm
                                id="ecap_acronym"
                                value={state.ecap_acronym}
                                label="Sigla do relatório"
                                onChange={onChange}
                            />
                        </div>
                    </div>
                </Card.Body>
            </Card>

            {
                userIsSentryDev &&
                <Card className="mt-3">
                    <Card.Header className="!flex !items-center !gap-2">
                        <Card.Title>Google Maps</Card.Title>
                    </Card.Header>

                    <Card.Body>
                        <div className="grid grid-cols-12 gap-4">
                            <InputForm
                                classNameWrapper={"col-span-12"}
                                id="maps_api_key"
                                value={state.maps_api_key}
                                label="Chave"
                                onChange={onChange}
                            />
                        </div>
                    </Card.Body>
                </Card>
            }

            <ModalAddress
                open={open}
                setOpen={setOpen}
                changeLocation={changeLocation}
                address={state}
            />
        </>
    );
};

export default CorporationData;